export default function checkProductAvailability (availableProducts, productId) {
  return availableProducts.includes(productId)
}
